//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Filters from "./components/Filters.vue";
import Sort from "./components/Sort.vue";
import Query from "./components/Query.vue";
import Result from "./components/Result.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
	name: "DoctorSearch",
	components: {
		Sort,
		Query,
		Result,
		Filters
	},
	mounted() {
	
	}
};
